import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  CreateRoleRequest,
  RoleDTO,
  UpdateRoleRequest,
} from '../types/role.types';

@Injectable({ providedIn: 'root' })
export class RolesService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.gatewayUrl}/auth/api/admin/roles`;

  list(): Observable<RoleDTO[]> {
    return this.http.get<RoleDTO[]>(this.base);
  }

  get(name: string): Observable<RoleDTO> {
    return this.http.get<RoleDTO>(`${this.base}/${encodeURIComponent(name)}`);
  }

  create(req: CreateRoleRequest): Observable<RoleDTO> {
    return this.http.post<RoleDTO>(this.base, req);
  }

  update(name: string, req: UpdateRoleRequest): Observable<RoleDTO> {
    return this.http.put<RoleDTO>(
      `${this.base}/${encodeURIComponent(name)}`,
      req,
    );
  }

  delete(name: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${encodeURIComponent(name)}`);
  }
}
